import "./Header.scss";
import ButtonRounded from "./ButtonRounded";

import HeaderLogo from "../../assets/images/header-logo.svg";
import React from "react";

export default function Header() {
	const handleScroll = (e) => {
		e.preventDefault(); // Prevent default anchor behavior

		try {
			const target = e.target.getAttribute("href");
			const targetElement = document.querySelector(target);
			const headerHeight = document.querySelector(".header").offsetHeight;

			const yOffset = -headerHeight; // Negative offset to account for the header
			const yPosition =
				targetElement.getBoundingClientRect().top +
				window.pageYOffset +
				yOffset;

			window.scrollTo({ top: yPosition, behavior: "smooth" });
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<div className="header">
			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					<a
						href="https://irisai.network"
						className="header-logo-link"
					>
						<img
							className="header-logo"
							src={HeaderLogo}
							alt="Header Logo"
							width="60"
							height="37"
						/>
					</a>
				</div>

				<div className="header-center">
					<nav className="header-nav">
						<ul className="header-nav-list">
							<li>
								<a href="#about-us" onClick={handleScroll}>
									<div className="btn-content">
										<div className="btn-txt">About Us</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#features" onClick={handleScroll}>
									<div className="btn-content">
										<div className="btn-txt">Features</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#faq" onClick={handleScroll}>
									<div className="btn-content">
										<div className="btn-txt">FAQs</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#contact-us" onClick={handleScroll}>
									<div className="btn-content">
										<div className="btn-txt">Contact Us</div>
									</div>
								</a>
							</li>
						</ul>
					</nav>
				</div>

				<div className="header-right">
					<ButtonRounded className="download-app-btn">
						Whitepaper
					</ButtonRounded>
				</div>
			</div>
		</div>
	);
}
